import {
  isSchemaDatapoint,
  SchemaDatapoint,
  SchemaItem,
  SchemaSection,
} from '@rossum/api-client/schemas';

/**
 * Recursively collects all datapoint fields from schema nodes.
 */
const collectDatapoints = (
  items: (SchemaSection | SchemaItem)[]
): SchemaDatapoint[] =>
  items.flatMap((item): SchemaDatapoint[] => {
    if (isSchemaDatapoint(item)) return [item];
    if ('children' in item) {
      const children = Array.isArray(item.children)
        ? item.children
        : [item.children];
      return collectDatapoints(children);
    }
    return [];
  });

/**
 * Collects all datapoint fields from a schema.
 * Can be used as a `select` function in `useSchema`.
 *
 * @example
 * useSchema(queue.schema, { select: getSchemaDatapoints })
 */
export const getSchemaDatapoints = (schema: {
  content?: SchemaSection[];
}): SchemaDatapoint[] => collectDatapoints(schema.content ?? []);
